import { Component, OnInit } from '@angular/core';
import { ConsignmentService } from '../../services/consignment.service';
import { ConsignmentProductService } from '../../services/consignment-product.service';
import { ProductService } from '../../../products/services/product.service';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
import { PersonService } from '../../../person/services/person.service';

@Component({
  selector: 'app-list-consignment',
  templateUrl: './list-consignment.component.html',
  styleUrls: ['./list-consignment.component.css'],
  providers:[ConsignmentService,ConsignmentProductService,ProductService,PersonService]
})
export class ListConsignmentComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  hideDropdown:boolean=false;
  consignments: any = [];
  filters:any = {
    nif: {contains: ""},
    name: {contains: ""},
    surname: {contains: ""}
  };
  productFilter:any = {
    brand:{contains: ""},
    model: {contains: ""},
    serial_number: {contains: ""},
    description: {contains: ""},
    imei:{contains: ""}
  };
  role:number = 3;
  fromDate:any;
  untilDate:any;
  telephone:any;
  person:any = {};

  constructor(private consignmentService: ConsignmentService, private consignmentProductService:ConsignmentProductService, private productService:ProductService, private personService:PersonService) { }

  ngOnInit() {
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
      if (location.href.split('?')[1]){
        this.filters = JSON.parse(localStorage.getItem('consignment-filter'));  
        this.productFilter = JSON.parse(localStorage.getItem('consignment-filter-product')); 
        this.getFilters();
      }else{
        this.getConsignments(null);
      }
    }catch(e){
      this.getConsignments(null);
    }
  }

  getFilters(){
    localStorage.setItem('consignment-filter',JSON.stringify(this.filters));
    localStorage.setItem('consignment-filter-product',JSON.stringify(this.productFilter));
    location.href = location.href.split('?')[0]+"?filters=true";
    this.person = {};
    if (this.telephone){
      this.getPerson().then(()=>{
        this.filterByConsigmentOrProduct();
      });
    }else{
      this.filterByConsigmentOrProduct();
    }
  }

  filterByConsigmentOrProduct(){
    if (this.productFilter.brand.contains != "" || this.productFilter.model.contains != "" ||
          this.productFilter.serial_number.contains != "" || this.productFilter.description.contains != "" || this.productFilter.imei.contains != ""){
            this.getConsignmentsByProducts();
      }else{
        this.getConsignments(null);
      }
  }

  getPerson(){
    return new Promise((resolve, reject) => {
        this.personService.query({telephone:this.telephone})
        .subscribe((people) => {
            this.person = people[0];
            console.log(this.person)
            resolve();
        });
    });
  }

  getConsignmentsByProducts(){
    let params = {
      where: _.cloneDeep(this.productFilter)
    };
    this.productService.query(params)
      .subscribe((products) => {
        var consignments = _.compact(products.map(e => e.consignmentProduct[0]?e.consignmentProduct[0].consignment:null));
        if (consignments.length > 0){
          this.getConsignments(consignments);
        }else{
          this.consignments = [];
        }
      });
  }

  getConsignments(prefilter){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (prefilter && !params.where.id){
      params.where.id = prefilter;
    }
    if (params.where.id == ""){
      delete params.where.id
    }
    if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
    }
    if (this.person.nif){
      params.where.nif = this.person.nif;
    }
    this.consignmentService.query(params)
      .subscribe((consignments) => {
        let countParams = {
          where: _.cloneDeep(params.where),
        };
        this.consignmentService.count(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
          this.consignments = consignments;
          this.getConsigmentProducts();
      });
  }

  getConsigmentProducts(){
    let params = {
      where: {
        consignment_id: this.consignments.map(e => e.id)
      }
    }
    this.consignmentProductService.query(params)
    .subscribe((consignmentsProducts) => {
       let groupedConsignmentProducts = _.groupBy(consignmentsProducts, (element)=> {return element.consignment.id})
       this.consignments.forEach( (p) =>{
         if (groupedConsignmentProducts[p.id] && groupedConsignmentProducts[p.id].length > 0){
          this.parseProductsDescription(p, groupedConsignmentProducts[p.id]);
         }
       });
     });
  }

  parseProductsDescription(element, groupedProducts){
    groupedProducts.forEach(products=>{
      element.productDescription = "";
      if (products.product.type){
        element.productDescription += this.getNameProductType(products.product.type)+"- ";
      }
      if (products.product.subType){
        element.productDescription += this.getNameSubType(products.product.sub_type,products.product.type)+"- ";
      }
      if (products.product.brand){
        element.productDescription += "Marca:"+products.product.brand+", ";
      }
      if (products.product.model){
        element.productDescription += "Modelo:"+products.product.model+", ";
      }
      if (products.product.telephone_company){
        element.productDescription += "Compañia:"+products.product.telephone_company+", ";
      }
      if (products.product.storage_capacity){
        element.productDescription += "Capacidad:"+products.product.storage_capacity+", ";
      }
      if (products.product.status){
        element.productDescription += "Estado:"+products.product.status+", ";
      }
      if (products.product.imei){
        element.productDescription += "Imei:"+products.product.imei+", ";
      }
      if (products.product.imei2){
        element.productDescription += "Imei2:"+products.product.imei2+", ";
      }
      if (products.product.serial_number){
        element.productDescription += "Número de serie:"+products.product.serial_number+", ";
      }
      if (products.product.so){
        element.productDescription += "Sistema Operativo:"+products.product.so+", ";
      }
      if (products.product.ram){
        element.productDescription += "Ram:"+products.product.ram+", ";
      }
      if (products.product.description){
        element.productDescription += "Descripción:"+products.product.description+", ";
      }
      element.productDescription = element.productDescription .slice(0, -2);
    });
  }

  getNameProductType(type){
    var productType= ["Móviles y Tablets","Consolas","Artículos Varios","PC's-portátiles"];
    return productType[type-1];
  }

  getNameSubType(subType, type){
    let subTypes = ["",""];  
    if (type == 1){
      subTypes =["Móvil","Tablet"];
    }else if (type == 4){
      subTypes =["PC","Portatil"];
    }
    return subTypes[subType-1];
  }

  delete(id){
    var r = confirm("¿Esta seguro de borrar esta consigna?");
    if (r == true) {
      let params = {
        where: {
          consignment_id: id
        }
      }
      this.consignmentProductService.query(params)
      .subscribe((purchaseProducts) => {
        purchaseProducts.forEach((e)=>{
          this.productService.delete(e.product.id).subscribe(()=>{});
          this.consignmentProductService.delete(e.id).subscribe(()=>{});
        });
      });
      this.consignmentService.delete(id).subscribe(()=>{
        this.getConsignments(null);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/consignment/components/list-consignment/list-consignment.component.ts